/**
 * Calculate banner display information based on current date
 * @returns {Object} Object containing banner display data
 * @returns {string} displayDate - Formatted upcoming Wednesday date (e.g., "Nov 20")
 * @returns {boolean} showBanner - Whether to show the banner based on current day/time
 */
export const getBannerInfo = () => {
  const today = new Date();
  const day = today.getDay(); // Sunday=0 , Monday=1 , Tuesday=2 , Wednesday=3

  // Calculate upcoming Wednesday
  const upcomingWednesday = new Date();
  upcomingWednesday.setDate(today.getDate() + ((3 - day + 7) % 7));
  upcomingWednesday.setHours(14, 0, 0, 0); // Wednesday cutoff time 2PM IST

  // Format Wednesday date (Ex: "Nov 20")
  const displayDate = upcomingWednesday.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric"
  });

  // Banner condition: Monday, Tuesday or Wednesday 
  const showBanner =
    day === 1 ||            // Monday
    day === 2 ||            // Tuesday
    day === 3;

  return {
    displayDate,
    showBanner,
    upcomingWednesday
  };
};
